/* eslint-disable import/prefer-default-export */
import IBase from './base';

// 自定义埋点
class IOtherPoint extends IBase {
  // 链路埋点
  pageviewFlow(refer, next) {
    this.opt('switch.pageview.flow', {
      referPageName: refer,
      pageName: next,
    });
  }


  h5Location(name) {
    this.opt('triggerExpose_switch_h5_location', {
      name,
    });
  }
}

export const OPT = new IOtherPoint();
